<div class="search-bus">
  <div
    class="ion-no-margin ion-margin-horizontal ion-margin-top d-flex ion-justify-content-between ion-align-items-center"
  ></div>

  <div class="search-container">
    <div class="ion-no-padding ion-padding-horizontal">
      <!-- Bus Search Card -->
      <div class="bus-search-card">
        <form [formGroup]="bookBusSearchForm" class="pad6">
          <!-- From/To Container with Switch Button -->
          <div class="station-selection-container">
            <!-- From Field -->
            <div class="ion-margin-bottom">
              <ion-item
                lines="none"
                class="field search ion-no-margin"
                (click)="getStation('source')"
              >
                <div
                  class="d-flex ion-justify-content-between ion-align-items-center w100 height100"
                >
                  <div class="align-label">
                    <ion-label position="stacked" class="fs-4 font400">
                      <ion-icon name="location"></ion-icon>
                      <span class="marl10 fs-4 font500">
                        {{ "bus.bus_search.from" | translate }}
                      </span>
                    </ion-label>
                    <ion-label
                      class="ion-no-padding ion-padding-top"
                      [ngClass]="
                        busQueryFields?.source
                          ? 'fs-3 font500 black-text '
                          : 'fs-3 font400 gray-text'
                      "
                    >
                      {{
                        busQueryFields?.source ||
                          ("bus.bus_search.from" | translate)
                      }}
                    </ion-label>
                  </div>
                </div>
              </ion-item>
              <div
                *ngIf="
                  bookBusSearchForm.get('source')?.invalid &&
                  (bookBusSearchForm.get('source')?.dirty ||
                    bookBusSearchForm.get('source')?.touched)
                "
              >
                <div
                  *ngIf="bookBusSearchForm.get('source')?.errors?.['required']"
                  class="validation-error mart5"
                >
                  {{ "bus.bus_search.source_is_required" | translate }}
                </div>
              </div>
            </div>

            <!-- To Field -->
            <div class="ion-margin-bottom">
              <ion-item
                lines="none"
                class="field search"
                (click)="getStation('destination')"
              >
                <div
                  class="d-flex ion-justify-content-between ion-align-items-center w100 height100"
                >
                  <div class="align-label">
                    <ion-label position="stacked" class="fs-4 font400">
                      <ion-icon name="location"></ion-icon>
                      <span class="marl10 fs-4 font500">
                        {{ "bus.bus_search.to" | translate }}
                      </span>
                    </ion-label>
                    <ion-label
                      class="ion-no-padding ion-padding-top"
                      [ngClass]="
                        busQueryFields?.destination
                          ? 'fs-3 font500 black-text '
                          : 'fs-3 font400 gray-text'
                      "
                    >
                      {{
                        busQueryFields?.destination ||
                          ("bus.bus_search.to" | translate)
                      }}
                    </ion-label>
                  </div>
                </div>
              </ion-item>
              <div
                *ngIf="
                  bookBusSearchForm.get('destination')?.invalid &&
                  (bookBusSearchForm.get('destination')?.dirty ||
                    bookBusSearchForm.get('destination')?.touched)
                "
              >
                <div
                  *ngIf="bookBusSearchForm.get('destination')?.errors?.['required']"
                  class="validation-error mart5"
                >
                  {{ "bus.bus_search.destination_is_required" | translate }}
                </div>
              </div>
              <div
                *ngIf="isSourceDestinationSame()"
                class="validation-error mart5"
              >
                {{
                  "bus.bus_search.source_and_destination_cannot_be_the_same"
                    | translate
                }}
              </div>
            </div>

            <!-- Switch Button -->
            <ion-button
              fill="clear"
              shape="round"
              (click)="switchSourceDestination()"
              class="switch-button"
              [ngClass]="{
                shiftorigin:
                  bookBusSearchForm.get('destination')?.invalid &&
                  (bookBusSearchForm.get('destination')?.dirty ||
                    bookBusSearchForm.get('destination')?.touched),
                shiftdestination:
                  bookBusSearchForm?.get('source')?.invalid &&
                  (bookBusSearchForm?.get('source')?.dirty ||
                    bookBusSearchForm?.get('source')?.touched)
              }"
            >
              <ion-icon name="swap-vertical"></ion-icon>
            </ion-button>
          </div>

          <!-- Date Field -->
          <div class="ion-margin-bottom">
            <ion-item lines="none" class="field ion-no-padding">
              <ion-label
                position="stacked"
                class="fs-4 font400 ion-padding-start"
              >
                <ion-icon name="calendar"></ion-icon>
                <span class="marl10 fs-4 font500">
                  {{ "bus.bus_search.date" | translate }}
                </span>
              </ion-label>

              <ion-input
                formControlName="departureDate"
                type="date"
                [min]="todayDate"
                max="9999-12-31"
                name="departure_date"
                [ngModel]="busQueryFields?.departureDate"
                (ngModelChange)="onDepartureDateChange($event)"
                (ionInput)="onDepartureDateChange($event.detail.value)"
                placeholder="{{ 'bus.bus_search.date' | translate }}"
                aria-label="date"
                class="fs-2 font500 marl4 date bus-date"
              >
              </ion-input>
              <div class="quick-date-options" slot="end">
                <ion-chip class="grey-primary-chip" (click)="selectToday()">
                  {{ "bus.bus_search.today" | translate }}
                </ion-chip>
                <ion-chip
                  class="grey-primary-chip"
                  (click)="selectTomorrow()"
                  >
                  {{ "bus.bus_search.tomorrow" | translate }}
                </ion-chip>
              </div>
            </ion-item>
            <div
              *ngIf="
                bookBusSearchForm.get('departureDate')?.invalid &&
                (bookBusSearchForm.get('departureDate')?.dirty ||
                  bookBusSearchForm.get('departureDate')?.touched)
              "
            >
              <div
                *ngIf="bookBusSearchForm.get('departureDate')?.errors?.['required']"
                class="validation-error mart5"
              >
                {{ "bus.bus_search.date_is_required" | translate }}
              </div>
              <div
                *ngIf="bookBusSearchForm.get('departureDate')?.errors?.['pastDate']"
                class="validation-error mart5"
              >
                {{ "bus.bus_search.date_cannot_be_in_past" | translate }}
              </div>
            </div>
          </div>

          <!-- Search Button -->
          <ion-button
            class="primary-btn search-btn ion-no-margin ion-margin-top fs-3 font500 marb5"
            expand="block"
            mode="ios"
            [disabled]="bookBusSearchForm.invalid || sourceDestinationSameError"
            (click)="handleSearch()"
          >
            {{ "bus.bus_search.search_buses" | translate }}
          </ion-button>
        </form>
      </div>
    </div>
  </div>

  <bus-recent-search
    *ngIf="recentSearches?.length"
    [recentSearches]="recentSearches"
    (recentSearchSelected)="onRecentSearchSelect($event)"
  ></bus-recent-search>
</div>
